"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styled = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const utils_1 = require("@obvio/utils");
const css_1 = require("./css");
const mediaqueries = __importStar(require("./mediaqueries"));
const selectors = __importStar(require("./selectors"));
__exportStar(require("./mediaqueries"), exports);
__exportStar(require("./css"), exports);
const isSelector = (key) => {
    return (0, utils_1.has)(selectors, key);
};
const isMedia = (key) => {
    return (0, utils_1.has)(mediaqueries, key);
};
const styledComponent = (component) => ((...args) => component((_a) => {
    var { theme } = _a, props = __rest(_a, ["theme"]);
    return (0, css_1.css)(...args)(theme, props);
}));
exports.styled = new Proxy(styled_1.default, {
    get: (obj, key, receiver) => {
        if (isSelector(key)) {
            return selectors[key];
        }
        if (isMedia(key)) {
            return (...args) => (0, css_1.css) `
        @media ${mediaqueries[key]} {
          ${(0, css_1.css)(...args)}
        }
      `;
        }
        const component = Reflect.apply(obj, receiver, [
            key,
            { shouldForwardProp: (prop) => !prop.startsWith('$') },
        ]);
        return styledComponent(component);
    },
    apply: (obj, thisArg, [comp, props, ...rest]) => {
        const component = Reflect.apply(obj, thisArg, [
            comp,
            Object.assign(Object.assign({}, props), { shouldForwardProp: (prop) => { var _a, _b; return !prop.startsWith('$') && ((_b = (_a = props === null || props === void 0 ? void 0 : props.shouldForwardProp) === null || _a === void 0 ? void 0 : _a.call(props, prop)) !== null && _b !== void 0 ? _b : true); } }),
            ...rest,
        ]);
        return styledComponent(component);
    },
});
